// extracted by mini-css-extract-plugin
export default {"container":"ReminderSuccessModal_container__F5esY","success-icon":"ReminderSuccessModal_success-icon__+B9OJ","title":"ReminderSuccessModal_title__-Z1Rb"};